import $ from 'jquery';
import jqueryBridget from 'jquery-bridget';
import Isotope from 'isotope-layout';
import 'isotope-packery';
jqueryBridget('isotope', Isotope, $);
function get_increment() {
  var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  // const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

  // TODO: abstract this universally useful breakpoint assessment JS lib
  if (vw <= 600) {
    return 4;
  } else if (vw <= 991) {
    return 5;
  } else {
    return 20;
  }
}
$(function () {
  var increment = get_increment();
  var count = increment; // get count from data-attr

  var $testimonials = $('.wp-block-testimonials-grid');
  var $testimonialsGrid = $testimonials.find('.wp-block-testimonials-grid__grid');
  var total = $testimonialsGrid.children().length;
  var remaining = Math.max(0, total - count);
  var isotopeOptions = {
    layoutMode: 'packery',
    filter: function filter() {
      var number = parseInt($(this).attr('data-nth'));
      return number <= count;
    }
  };

  // init remaining for pagination
  $testimonials.attr('data-remaining', remaining);

  // init isotope
  $testimonialsGrid.isotope(isotopeOptions);

  // retrigger isotope once fonts are loaded
  document.fonts.ready.then(function () {
    $testimonialsGrid.isotope(isotopeOptions);
  });

  // Show more
  var $showMore = $testimonials.find('.wp-block-testimonials-showMore');
  $showMore.on('click', function () {
    count = Math.min(count + increment, total);
    remaining = total - count;
    $testimonialsGrid.isotope(isotopeOptions);
    $testimonials.attr('data-remaining', remaining);
    $(this).trigger('blur');
  });
});